<template>
  <div class="container">
    <div class="search_box">
      <v-search :searchType="'carInfo'" :limit="tableParams.limit" @searchParams="searchChange($event)"></v-search>
    </div>
    <div class="table_box">
      <el-table ref="singleTable" :data="tableData" highlight-current-row style="width: 100%" stripe
        v-loading="tableLoading">
        <el-table-column property="carNum" label="序号" align="center" width="50">
        </el-table-column>
        <el-table-column property="carNumber" label="车牌号码">
        </el-table-column>
        <el-table-column property="carColorStr" label="车牌颜色">
        </el-table-column>
        <el-table-column property="carServiceStr" label="车辆营运性质">
        </el-table-column>
        <el-table-column property="driverTime" label="行驶证注册日期" sortable width="180">
        </el-table-column>
        <el-table-column property="validityPeriodTime" label="年审有效期" sortable width="180">
        </el-table-column>
        <el-table-column property="maintainTime" label="二级维护有效期" sortable width="180">
        </el-table-column>
        <el-table-column property="technicalGradeTime" label="技术等级有效期" sortable width="180">
        </el-table-column>
        <el-table-column label="操作" width="120" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="goRedact(scope.row)">编辑</el-button>
            <el-button type="text" @click="goDetail(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="paging_box">
      <!--  :current-page="currentPage4" -->
      <el-pagination @size-change="handleSizeChange" background @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 50, 100]" :page-size.sync="tableParams.limit" :current-page.sync="tableParams.page"
        layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>

    <v-redactCar :dialogData="redactData" :dialogShow.sync="redactShow"></v-redactCar>
    <v-detail :dialogShow.sync="detailShow" :dialogData="detailData"></v-detail>
    <v-addCar :dialogShow.sync="addCarShow"></v-addCar>
  </div>
</template>

<script>
import search from "@/components/search.vue";
import redactCar from "./carInfo_component/redactCar.vue";
import detail from "./carInfo_component/detail.vue";
import addCar from "./carInfo_component/addCar.vue";
import { exportExcel } from "@/utils/util";
export default {
  name: "carInfo",
  data () {
    return {
      tableData: [],
      tableLoading: false,
      addCarShow: false,
      redactShow: false,
      detailShow: false,
      dimissionDilogShow: false,
      redactData: {},
      detailData: {},
      dimissionDilogData: {},
      tableParams: {
        carColor: "",
        carNumber: "",
        carService: "",
        carState: "",
        limit: 10,
        page: 1,
        isPage: true
      },
      total: 0,
    };
  },
  components: {
    "v-search": search,
    "v-redactCar": redactCar,
    "v-detail": detail,
    "v-addCar": addCar,
  },
  props: {},
  created () {
    this.getList();
  },
  methods: {
    getList (data) {
      this.tableParams.isPage = true;
      let params = data ? data : this.tableParams;
      this.tableLoading = true;
      this.$http.getCarList(params).then((res) => {
        this.tableLoading = false;
        if (res.code === 0) {
          this.tableData = res.data;
          this.total = res.count;
        } else {
          this.tableData = [];
          this.total = 0;
          this.$message.error(res.msg);
        }
      });
    },
    // 事件处理函数
    async searchChange (value) {
      this.tableParams = value;
    },
    handleSizeChange (val) {
      this.tableParams.limit = val;
      this.tableParams.page = 1;
      this.getList();
    },
    handleCurrentChange (val) {
      this.tableParams.page = val;
      this.getList();
    },
    goRedact (row) {
      this.redactData = row;
      this.redactShow = true;
    },
    goDetail (row) {
      this.detailData = row;
      this.detailShow = true;
    },
    goDimission (row) {
      this.dimissionDilogData = row;
      this.dimissionDilogShow = true;
    },
    addFunction () {
      this.addCarShow = true;
    },
    downloadExport () {
      this.tableParams.isPage = false;
      this.$http.getCarList(this.tableParams).then((res) => {
        if (res.code === 0) {
          const exportExcelList = res.data;
          // 表头
          const tHeader = [
            "序号",
            "车牌号码",
            "车牌颜色",
            "车辆营运性质",
            "行驶证注册日期",
            "年审有效期",
            "二级维护有效期",
            "技术等级有效期"
          ];
          // table表格中对应的属性名
          const filterVal = [
            "number",
            "carNumber",
            "carColorStr",
            "carServiceStr",
            "driverTime",
            "validityPeriodTime",
            "maintainTime",
            "technicalGradeTime"
          ];
          exportExcel(tHeader, filterVal, exportExcelList, this.$route.name);
        } else {
          this.$message.info(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/comm.less";
</style>



// WEBPACK FOOTER //
// src/views/carAdmin/carInfo.vue